export { ReactComponent as BackgroundPattern } from './background.svg';
export { ReactComponent as GreenPattern } from './green.svg';
export { ReactComponent as MenuTilePattern } from './menu-tile.svg';
export { ReactComponent as TestimonialPattern } from './testimonial.svg';
export { ReactComponent as WhiteBottomPattern } from './white-bottom.svg';
export { ReactComponent as WhiteTopPattern } from './white-top.svg';
export { ReactComponent as WhiteVerticalPattern } from './white-vertical.svg';
export * as modalPattern from './modal.png';
